import { axiosClient } from '@nx-frontend/shared/api';
import { assertServiceHost } from '@nx-frontend/shared/api/services/util';
import { CacheStrategy, PortalServiceContentDto } from '@nx-frontend/shared/types';
import { PortalContentProps } from './portal-content-types';

export type GetPortalContentProps = PortalContentProps & {
  superSecret: string;
  path?: string;
  userId?: number;
  permissionsMode?: 'client' | 'admin';
  cacheStrategy: CacheStrategy;
};

export async function getPortalContent({
  host,
  path,
  superSecret,
  ...restProps
}: GetPortalContentProps): Promise<PortalServiceContentDto> {
  const response = await axiosClient.get<PortalServiceContentDto>(`${assertServiceHost(host)}/v1/contents`, {
    params: {
      path,
      ...restProps,
    },
    secret: superSecret,
  });

  return response.data;
}
